var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"id":"footer"}},[_c('el-col',{attrs:{"span":24,"id":"footer-content"}},[_c('p',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("沪ICP备2022014867-1号")])]),_c('p',[_vm._v("Powered By Vue 2.7.10 & ElementUi 2.15.9")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }